import Store from 'store/store';
import { visibleRatio } from 'utils/visibilityChecks';

Store.on('SET_ACTIVE_PAGE', page => {
	if (!page) return;
	if (page === 'home' || page === 'intro') {
		fire('site-scroll', 'scroll', 'landing');
	} else if (page === 'signUp') {
		fire('site-scroll', 'scroll', 'sign-up');
	} else if (page === 'tasteShopExplore') {
		fire('site-scroll', 'scroll', 'explore');
	} 
});
Store.on('TRACK_BANNER_CLICK', () => fire('banner-click', 'marquee', '-'));
Store.on('TRACK_PRIVACY_CLICK', () => fire('privacy-click', 'signUp-privacy', '-'));
Store.on('KLAVIYO_SIGNUP_FORM_SUBMIT', ({ location }) => {
	fire('form_submit', 'signUp', '-');
	
	loadFB();
	fbq('init', '989907563354956');
	fbq('track', 'PageView');
	fbq('track', 'Lead', { location });
});
Store.on('UPDATE_FOOTER_ACTIVE_PERCENTAGE', () => {
	const footerElem = document.querySelector('[data-section=boltFooter]');
	const percentage = visibleRatio(footerElem);
	if (percentage === undefined) return;
	const footerStore = Store.get().footer;
	if (!footerStore) {
		Store.get().set({ footer: { activePercentage: 0, hasLogged: false } });
	}
	const rounded = Math.ceil(percentage * 10) / 10;
	if (rounded !== footerStore.footerActivePercentage) {
		footerStore.set({ activePercentage: rounded });
		if (rounded === 1 && !footerStore.hasLogged) {
			fire('site-scroll', 'scroll', 'footer');
			footerStore.set({ hasLogged: true });
			return;
		}
		if (rounded !== 1) {
			footerStore.set({ hasLogged: false });
		}
	}
});



const fire = (action, cat, label) => {
	if (!window.firePowsterCustomEvent) return;
	const acceptedCats = window.powCategories?.get() || [];
	if (!acceptedCats.includes('PERFORMANCE')) return;
	window.firePowsterCustomEvent(action, cat, label);
};

function loadFB() {
	!function(f,b,e,v,n,t,s)
	{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
	n.callMethod.apply(n,arguments):n.queue.push(arguments)};
	if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
	n.queue=[];t=b.createElement(e);t.async=!0;
	t.src=v;s=b.getElementsByTagName(e)[0];
	s.parentNode.insertBefore(t,s);}(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');

	const noscript = document.createElement('noscript');
	const img = document.createElement('img');
	img.height = 1;
	img.width = 1;
	img.style.display = 'none';
	img.src = 'https://www.facebook.com/tr?id=989907563354956&ev=PageView&noscript=1';
	noscript.appendChild(img);
	document.body.appendChild(noscript);
}